import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/components/ui/select'
import { setSelectedReferenceField } from '@/redux/store/slices/map/mapSlice'
import { enabledReferenceFields, referenceFieldStringMap } from '@/utils'
import { useAppDispatch, useAppSelector } from '@redux/hooks/useAppState'
import { ReferenceFields } from 'honeygrid-types'

import type { DataSourceFieldMappings } from 'honeygrid-types/validators-and-types/DataSourceTypes'
import type { FC } from 'react'

interface ReferenceFieldSelectProps {
	customDataKeys?: string[]
	fieldMappings?: DataSourceFieldMappings
}

export const ReferenceFieldSelect: FC<ReferenceFieldSelectProps> = ({
	customDataKeys = [],
	fieldMappings = {},
}) => {
	const selectedReferenceField = useAppSelector((state) => state.map.selectedReferenceField)
	const dispatch = useAppDispatch()

	const handleValueChange = (value: string) => {
		dispatch(setSelectedReferenceField(value))
	}

	return (
		<div className="absolute left-3 top-3 z-[3]">
			<Select
				value={selectedReferenceField ?? ReferenceFields.Households}
				onValueChange={handleValueChange}
			>
				<SelectTrigger className="max-w-[250px] bg-background shadow-md">
					<SelectValue placeholder="Select data to view" />
				</SelectTrigger>
				<SelectContent>
					{customDataKeys?.map((key) => (
						<SelectItem key={key} value={key}>
							{fieldMappings?.[key]?.friendlyName || key}
						</SelectItem>
					))}
					{enabledReferenceFields.map((field) => (
						<SelectItem key={field} value={field}>
							{referenceFieldStringMap[field]}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	)
}
